import { localesMap, localesStringMap } from '../constants/localeConstats'
import { Locales, LocalesStrings } from '../types/locales'

export const getLocaleString = (locale: Locales): LocalesStrings => {
    return localesMap[locale]
}

export const getLocaleValue = (locale: LocalesStrings): Locales => {
    return localesStringMap[locale]
}
